/* eslint-disable */
import  {
    React, useEffect, useState, $, useLocation, queryString,
    useActionUrl, Form, Table, MetaTable,
    PageHeader, CompanyRoutes, useFormInit, getGetParam, showMessage, showUserMessage
}  from 'library/base/baseContainerImports';

import 'webfontloader';

const GlobalStyles = ( {loadUrl} ) => {

    const {getFullUrl}      = useActionUrl();
    const settingsModule    = CompanyRoutes.ADMIN.REGISTRATION_FORM.SETTINGS;
    const viewAction        = loadUrl ? loadUrl : getFullUrl(settingsModule.path, {'load':'data'});

    let styles = {
        "headerFontSize"        : "25",
        "headerFontName"        : "arial, sans-serif",
        "headerColour"          : "black",
        "bodyFontSize"          : "13",
        "bodyFontName"          : "arial, sans-serif",
        "bodyColour"            : "black",
        "componentBorderColour" : "black",
        "buttonTextColour"      : "black",
        "buttonBackgroundColour": "",
    };

    const rootStyles = `
         :root {
            --form-header-font-size: `  + styles.headerFontSize + `px;
            --form-header-font-name: ` + styles.headerFontName + `;
            --form-header-font-color: ` + styles.headerColour + `;
            --form-body-font-size: `  + styles.bodyFontSize + `px;
            --form-body-font-name: ` + styles.bodyFontName + `;
            --form-body-font-color: ` + styles.bodyColour + `;
            --form-button-font-color: ` + styles.buttonTextColour + `;
            --form-button-bg-color: ` + styles.buttonBackgroundColour + `;
            --form-component-border-color: ` + styles.componentBorderColour + `;
        }
    `;

    const [brandStyles, setBrandStyles] = useState(rootStyles);

    const initForm = () => {
        $.get(viewAction, function (data) {

            if (data.imports.length){
                var WebFont = require('webfontloader');
                WebFont.load({
                    google: {
                        families: data.imports
                    }
                });
            }

            styles = data.options;
            const rootStyles = `
                 :root {
                    --form-header-font-size: `  + styles.headerFontSize + `px;
                    --form-header-font-name: ` + '"' + styles.headerFontName + '"' + `;
                    --form-header-font-color: ` + styles.headerColour + `;
                    --form-body-font-size: `  + styles.bodyFontSize + `px;
                    --form-body-font-name: ` + '"' + styles.bodyFontName + '"' + `;
                    --form-body-font-color: ` + styles.bodyColour + `;
                    --form-button-font-color: ` + styles.buttonTextColour + `;
                    --form-button-bg-color: ` + styles.buttonBackgroundColour + `;
                    --form-component-border-color: ` + styles.componentBorderColour + `;
                }`;
            setBrandStyles(rootStyles)
            return false;
        });
    };



    useEffect(() => {
        // Initialise default
        initForm();
    }, []);

    return (
        <>
            <style>{brandStyles}</style>
        </>
    );
};

export default GlobalStyles;